<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-09",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 29,
      nextPage: '/questionnaire/section2/10',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Skin.png'),
        mainTitle: 'What is your skin condition?',
        btn: [
          [
            {
              text: 'Dry',
            }
          ],[
            {
              text: 'Oil',
            }
          ],[
            {
              text: 'Normal',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
